/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import Cookies, {CookieAttributes} from "js-cookie";

export const setCookie = (key: string, value: string, args?: CookieAttributes) => {
    Cookies.set(key, value, {...args})
}

export const removeCookie = (key: string, args?: CookieAttributes) => {
    Cookies.remove(key, args);
};

export const getCookie = (key: string): string | undefined => {
    return Cookies.get(key);
}